import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";

interface ValidationMetricsSectionProps {
  marketValidation: string;
  setMarketValidation: (value: string) => void;
  benchmarkRequested: boolean;
  setBenchmarkRequested: (value: boolean) => void;
  churnRate: string;
  setChurnRate: (value: string) => void;
  customerLTV: string;
  setCustomerLTV: (value: string) => void;
  customerCAC: string;
  setCustomerCAC: (value: string) => void;
}

export const ValidationMetricsSection = ({
  marketValidation,
  setMarketValidation,
  benchmarkRequested,
  setBenchmarkRequested,
  churnRate,
  setChurnRate,
  customerLTV,
  setCustomerLTV,
  customerCAC,
  setCustomerCAC,
}: ValidationMetricsSectionProps) => {
  return (
    <div className="space-y-4">
      <div>
        <Label>Market Validation</Label>
        <Select value={marketValidation} onValueChange={setMarketValidation}>
          <SelectTrigger>
            <SelectValue placeholder="Select validation status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Yes">Yes</SelectItem>
            <SelectItem value="No">No</SelectItem>
            <SelectItem value="Partially">Partially</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          checked={benchmarkRequested}
          onCheckedChange={(checked) => setBenchmarkRequested(checked as boolean)}
        />
        <Label>Benchmark against similar startups</Label>
      </div>

      <div>
        <Label>Churn Rate (% annually)</Label>
        <Input
          type="number"
          value={churnRate}
          onChange={(e) => setChurnRate(e.target.value)}
          placeholder="e.g., 10"
        />
      </div>

      <div>
        <Label>Customer Lifetime Value (LTV)</Label>
        <Input
          type="number"
          value={customerLTV}
          onChange={(e) => setCustomerLTV(e.target.value)}
          placeholder="e.g., 500"
        />
      </div>

      <div>
        <Label>Customer Acquisition Cost (CAC)</Label>
        <Input
          type="number"
          value={customerCAC}
          onChange={(e) => setCustomerCAC(e.target.value)}
          placeholder="e.g., 50"
        />
      </div>
    </div>
  );
};